enum JourneyPaths {
  LEARN_MORE = "/fle/journey/learn-more",
  NEXT_STEP = "/fle/journey/next-step",
  INITIAL_CONSULTATION = "/fle/journey/initial-consultation",
  TALKED_TO_DOCTOR = "/fle/journey/talked-to-doctor",
  STARTED_SEEING_DOCTOR = "/fle/journey/started-seeing-doctor",
  DONE = "/fle/done"
}

export { JourneyPaths }
